import { useStores } from 'hooks';
import { useMemo } from 'react';
import _ from 'lodash';

const useSidebar = () => {
  const { authStore: p } = useStores();
  const itemGroups = [
    [{
      name: 'Dashboard',
      path: '/dashboard',
      icon: 'fas fa-tachometer-alt fa-gradient',
      isVisible: () => p.hasPermission(['supplier/dashboard', 'partner/dashboard', 'company/dashboard', 'dashboard']),
    }],
    [{
      name: 'Page Setting',
      path: '/page_settings',
      icon: 'fas fa-palette',
      isVisible: () => p.hasPermission(['owner']),
    },{
      name: 'Hero Banners',
      path: '/hero_banners',
      icon: 'fas fa-star',
      isVisible: () => p.hasPermission(['owner']),
    },
    {
      name: 'Campaign',
      path: '/campaigns',
      icon: 'fas fa-fire-alt',
      isVisible: () => p.hasPermission(['owner']),
    },
    {
      name: 'Categories',
      path: '/categories',
      icon: 'fas fa-cubes',
      isVisible: () => p.hasPermission(['owner']),
    },
    {
      name: 'Tags',
      path: '/tags',
      icon: 'fas fa-tag',
      isVisible: () => p.hasPermission(['owner']),
    },{
      name: 'Amaz Social',
      path: '/socials',
      icon: 'fas fa-share-alt',
      isVisible: () => p.hasPermission(['owner']),
    },],
    [{
      name: 'Partners',
      path: '/partners',
      icon: 'far fa-handshake',
      isVisible: () => p.hasPermission(['partners/list', 'owner']),
    },
    {
      name: 'Suppliers',
      path: '/suppliers',
      icon: 'fas fa-store',
      isVisible: () => p.hasPermission(['suppliers/list', 'owner']),
    },
    {
      name: 'Companies',
      icon: 'far fa-building',
      path: '/companies',
      isVisible: () => p.hasPermission(['companies/edit', 'owner']),
    },
    {
      name: 'Pricing Tiers',
      path: '/pricing_tiers',
      icon: 'far fa-star',
      isVisible: () => p.hasPermission(['owner']),
    }],
    [{
      name: 'Employees',
      path: '/employees',
      icon: 'fas fa-user-tie',
      isVisible: () => p.hasPermission(['employees/list']),
    }],
    [{
      name: 'Perks',
      path: '/perks',
      icon: 'fas fa-certificate',
      isVisible: () => p.hasPermission(['owner', 'portalPerks/list']),
    },
    {
      name: 'Perk Vendors',
      path: '/perk_vendors',
      icon: 'fas fa-certificate',
      isVisible: () => p.hasPermission(['owner', 'portalPerkVendors/list']),
    }],
    [{
      name: 'Events',
      path: '/events',
      icon: 'far fa-calendar-alt',
      isVisible: () => p.hasPermission(['events/list_portal']),
    },
    {
      name: 'Event Registration',
      path: '/events/registration',
      icon: 'far fa-calendar-alt',
      isVisible: () => p.hasPermission(['events/list_registration']),
    }],
    [{
      name: 'Products',
      icon: 'fas fa-boxes',
      path: '/products',
      isVisible: () => p.hasPermission(['amaz_products/edit']),
    },
    {
      name: 'Shipping Setting',
      path: '/shipping',
      icon: 'fas fa-ellipsis-v',
      isVisible: () => p.hasPermission(['amaz_fulfillment_types/list']),
    }],
    [{
      name: 'Orders',
      path: '/orders',
      icon: 'fas fa-shipping-fast',
      isVisible: () => p.hasPermission(['amaz_orders/list', 'owner']),
    },
    {
      name: 'Invoices',
      path: '/invoices',
      icon: 'fas fa-file-invoice',
      isVisible: () => p.hasPermission(['amaz_invoices/view', 'owner']),
    },
    {
      name: 'Refund',
      path: '/refund',
      icon: 'fas fa-hand-holding-usd',
      isVisible: () => p.hasPermission(['refund/list', 'owner']),
    },
    {
      name: 'Coupon Management',
      path: '/coupons',
      icon: 'fas fa-ticket-alt',
      isVisible: () => p.hasPermission(['amaz_coupons/list']),
    },
    {
      name: 'Sales Report',
      path: '/sales_report',
      icon: 'fas fa-download',
      isVisible: () => p.hasPermission(['suppliers/getSalesRecords']) && !p.hasPermission(['owner']),
    }],
    [{
      name: 'Upload File',
      path: '/upload',
      icon: 'fas fa-cloud-upload-alt',
      isVisible: () => p.hasPermission(['owner', 'amaz_products/edit']),
    },
    {
      name: 'My Supplier Setting',
      path: '/suppliers/edit/me',
      icon: 'fas fa-cog',
      isVisible: () => p.hasPermission(['suppliers/edit/me']),
    },
    {
      name: 'My Company Setting',
      path: '/companies/edit/me',
      icon: 'fas fa-cog',
      isVisible: () => p.hasPermission(['companies/edit/me']),
    }],
  ];
  const isVisible = (i) => _.isNil(i.isVisible) || i.isVisible();
  return useMemo(() => itemGroups
    .map((items) => items.map((i) => ({
      ...i,
      isVisible: isVisible(i),
    }))
      .filter((i) => i.isVisible))
    .filter((items) => items.length),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [p.permissions]);
};

export default useSidebar;
